'use client'

import AOS from 'aos'
import { type ReactNode, useEffect } from 'react'

export function AOSProvider({ children }: { children: ReactNode }) {
	useEffect(() => {
		AOS.init({
			duration: 1000, // Animation duration
			once: true, // Whether animation should happen only once - while scrolling down
		})
	}, [])
	return <>{children}</>
}
